import { render, staticRenderFns } from "./SzfBaseQuery.vue?vue&type=template&id=64e600bb&scoped=true&"
import script from "./SzfBaseQuery.vue?vue&type=script&lang=js&"
export * from "./SzfBaseQuery.vue?vue&type=script&lang=js&"
import style1 from "./SzfBaseQuery.vue?vue&type=style&index=1&id=64e600bb&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64e600bb",
  null
  
)

export default component.exports